import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "asset-notification-rules" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-header border-0 pt-6" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = { class: "card-body pt-0" }
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = { class: "text-muted" }
const _hoisted_9 = { class: "d-flex align-items-center justify-content-center gap-2" }
const _hoisted_10 = ["title", "onClick"]
const _hoisted_11 = ["title", "onClick"]
const _hoisted_12 = ["title", "onClick"]
const _hoisted_13 = {
  class: "modal fade",
  id: "ruleModal",
  tabindex: "-1",
  ref: "ruleModalRef"
}
const _hoisted_14 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_15 = { class: "modal-content" }
const _hoisted_16 = { class: "modal-header" }
const _hoisted_17 = { class: "modal-title" }
const _hoisted_18 = { class: "modal-body" }
const _hoisted_19 = { class: "mb-3" }
const _hoisted_20 = { class: "form-label required" }
const _hoisted_21 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_22 = { class: "mb-3" }
const _hoisted_23 = { class: "form-label" }
const _hoisted_24 = { class: "mb-3" }
const _hoisted_25 = { class: "form-label required" }
const _hoisted_26 = { value: "asset" }
const _hoisted_27 = { value: "group" }
const _hoisted_28 = {
  key: 0,
  value: "gateway"
}
const _hoisted_29 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_30 = { class: "form-label required" }
const _hoisted_31 = { value: null }
const _hoisted_32 = ["value"]
const _hoisted_33 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_34 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_35 = { class: "form-label required" }
const _hoisted_36 = { value: null }
const _hoisted_37 = ["value"]
const _hoisted_38 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_39 = {
  key: 2,
  class: "mb-3"
}
const _hoisted_40 = { class: "form-label required" }
const _hoisted_41 = { value: null }
const _hoisted_42 = ["value"]
const _hoisted_43 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_44 = { class: "mb-3" }
const _hoisted_45 = { class: "form-label required" }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = { value: null }
const _hoisted_48 = ["value"]
const _hoisted_49 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_50 = {
  key: 3,
  class: "row"
}
const _hoisted_51 = { class: "col-md-6 mb-3" }
const _hoisted_52 = { class: "form-label required" }
const _hoisted_53 = {
  key: 0,
  value: "greater_than"
}
const _hoisted_54 = {
  key: 1,
  value: "less_than"
}
const _hoisted_55 = { value: "equals" }
const _hoisted_56 = {
  key: 2,
  value: "between"
}
const _hoisted_57 = {
  key: 3,
  value: "outside_range"
}
const _hoisted_58 = { class: "col-md-3 mb-3" }
const _hoisted_59 = { class: "form-label required" }
const _hoisted_60 = {
  key: 0,
  class: "col-md-3 mb-3"
}
const _hoisted_61 = { class: "form-label required" }
const _hoisted_62 = {
  key: 4,
  class: "mb-3"
}
const _hoisted_63 = { class: "form-label required" }
const _hoisted_64 = { class: "d-flex flex-wrap gap-3" }
const _hoisted_65 = { class: "form-check" }
const _hoisted_66 = ["checked"]
const _hoisted_67 = {
  class: "form-check-label",
  for: "booleanThresholdTrue"
}
const _hoisted_68 = { class: "form-check" }
const _hoisted_69 = ["checked"]
const _hoisted_70 = {
  class: "form-check-label",
  for: "booleanThresholdFalse"
}
const _hoisted_71 = {
  key: 5,
  class: "mb-3"
}
const _hoisted_72 = { class: "form-label required" }
const _hoisted_73 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_74 = {
  key: 1,
  class: "form-text"
}
const _hoisted_75 = {
  key: 6,
  class: "mb-3"
}
const _hoisted_76 = { class: "form-label" }
const _hoisted_77 = { value: null }
const _hoisted_78 = ["value"]
const _hoisted_79 = { class: "mb-3" }
const _hoisted_80 = { class: "form-label d-block" }
const _hoisted_81 = { class: "d-flex flex-wrap gap-3" }
const _hoisted_82 = { class: "form-check" }
const _hoisted_83 = { class: "form-check" }
const _hoisted_84 = { class: "form-check" }
const _hoisted_85 = { class: "mb-3" }
const _hoisted_86 = { class: "form-check form-switch" }
const _hoisted_87 = {
  class: "form-check-label",
  for: "isActive"
}
const _hoisted_88 = { class: "border rounded p-3 bg-light-subtle" }
const _hoisted_89 = { class: "row g-3" }
const _hoisted_90 = { class: "col-md-4" }
const _hoisted_91 = {
  class: "form-label",
  for: "repeatsPerSeries"
}
const _hoisted_92 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_93 = { class: "col-md-4" }
const _hoisted_94 = {
  class: "form-label",
  for: "repeatIntervalMinutes"
}
const _hoisted_95 = ["disabled"]
const _hoisted_96 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_97 = {
  key: 1,
  class: "form-text"
}
const _hoisted_98 = { class: "col-md-4" }
const _hoisted_99 = ["disabled"]
const _hoisted_100 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_101 = {
  key: 1,
  class: "form-text"
}
const _hoisted_102 = { class: "mt-2 text-muted small" }
const _hoisted_103 = { class: "modal-footer" }
const _hoisted_104 = ["disabled"]
const _hoisted_105 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('components.assetNotificationRules.title')), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (!_ctx.isReadOnly)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-sm btn-primary",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCreateModal && _ctx.openCreateModal(...args)))
              }, [
                _cache[30] || (_cache[30] = _createElementVNode("i", { class: "bi bi-plus-circle" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetNotificationRules.create')), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_DxDataGrid, {
          ref: "rulesGrid",
          "data-source": _ctx.rulesDataSource,
          "allow-column-reordering": true,
          "allow-column-resizing": true,
          "column-auto-width": true,
          "hover-state-enabled": true,
          "show-borders": true,
          "show-column-lines": true,
          "remote-operations": true,
          "key-expr": "id"
        }, {
          targetAssetTemplate: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", null, _toDisplayString(_ctx.getTargetDisplayName(data.data)), 1),
              _createElementVNode("small", _hoisted_8, _toDisplayString(_ctx.getTargetDisplayMeta(data.data)), 1)
            ])
          ]),
          actionsTemplate: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-icon btn-sm btn-light-primary",
                title: _ctx.$t('components.assetNotificationRules.edit'),
                onClick: ($event: any) => (_ctx.openEditModal({ row: data }))
              }, [...(_cache[31] || (_cache[31] = [
                _createElementVNode("i", { class: "bi bi-pencil" }, null, -1)
              ]))], 8, _hoisted_10),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["btn btn-icon btn-sm", data.data.isActive ? 'btn-light-warning' : 'btn-light-success']),
                title: data.data.isActive
                  ? _ctx.$t('components.assetNotificationRules.deactivate')
                  : _ctx.$t('components.assetNotificationRules.activate'),
                onClick: ($event: any) => (_ctx.toggleRuleActiveState(data.data))
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(data.data.isActive ? 'bi bi-pause-circle' : 'bi bi-play-circle')
                }, null, 2)
              ], 10, _hoisted_11),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-icon btn-sm btn-light-danger",
                title: _ctx.$t('components.assetNotificationRules.deletePermanent'),
                onClick: ($event: any) => (_ctx.deleteRule(data.data))
              }, [...(_cache[32] || (_cache[32] = [
                _createElementVNode("i", { class: "bi bi-trash" }, null, -1)
              ]))], 8, _hoisted_12)
            ])
          ]),
          parameterTemplate: _withCtx(({ data }) => [
            _createElementVNode("span", null, _toDisplayString(_ctx.getParameterDisplayName(data.data.canParamsIo?.paramName)), 1)
          ]),
          conditionTemplate: _withCtx(({ data }) => [
            _createElementVNode("span", null, _toDisplayString(_ctx.getConditionDisplay(data.data)), 1)
          ]),
          channelsTemplate: _withCtx(({ data }) => [
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.data.notificationChannels, (channel) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: channel,
                  class: _normalizeClass(["badge me-1", {
                  'badge-primary': channel === 'email',
                  'badge-success': channel === 'sms',
                  'badge-info': channel === 'mercure'
                }])
                }, _toDisplayString(channel.toUpperCase()), 3))
              }), 128))
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_DxPaging, { "page-size": 20 }),
            _createVNode(_component_DxPager, {
              "allowed-page-sizes": [10, 20, 50],
              "show-info": true,
              "show-navigation-buttons": true,
              "show-page-size-selector": true,
              visible: true
            }),
            _createVNode(_component_DxSearchPanel, {
              visible: true,
              placeholder: _ctx.$t('components.assetNotificationRules.search')
            }, null, 8, ["placeholder"]),
            _createVNode(_component_DxColumn, {
              "data-field": "name",
              caption: _ctx.$t('components.assetNotificationRules.columns.name'),
              width: 180
            }, null, 8, ["caption"]),
            _createVNode(_component_DxColumn, {
              "data-field": "targetAsset.name",
              caption: _ctx.$t('components.assetNotificationRules.columns.target'),
              width: 180,
              "cell-template": "targetAssetTemplate"
            }, null, 8, ["caption"]),
            _createVNode(_component_DxColumn, {
              "data-field": "canParamsIo.paramName",
              caption: _ctx.$t('components.assetNotificationRules.columns.parameter'),
              width: 150,
              "cell-template": "parameterTemplate"
            }, null, 8, ["caption"]),
            _createVNode(_component_DxColumn, {
              "data-field": "conditionType",
              caption: _ctx.$t('components.assetNotificationRules.columns.condition'),
              width: 120,
              "cell-template": "conditionTemplate"
            }, null, 8, ["caption"]),
            _createVNode(_component_DxColumn, {
              "data-field": "notificationChannels",
              caption: _ctx.$t('components.assetNotificationRules.columns.channels'),
              width: 200,
              "cell-template": "channelsTemplate"
            }, null, 8, ["caption"]),
            _createVNode(_component_DxColumn, {
              "data-field": "isActive",
              caption: _ctx.$t('components.assetNotificationRules.columns.active'),
              "data-type": "boolean",
              width: 80,
              alignment: "center"
            }, null, 8, ["caption"]),
            (!_ctx.isReadOnly)
              ? (_openBlock(), _createBlock(_component_DxColumn, {
                  key: 0,
                  caption: _ctx.$t('components.assetNotificationRules.columns.actions'),
                  width: 170,
                  alignment: "center",
                  "cell-template": "actionsTemplate"
                }, null, 8, ["caption"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["data-source"])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("h5", _hoisted_17, _toDisplayString(_ctx.editingRule ? _ctx.$t('components.assetNotificationRules.editTitle') : _ctx.$t('components.assetNotificationRules.createTitle')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            })
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("form", {
              onSubmit: _cache[27] || (_cache[27] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveRule && _ctx.saveRule(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.name')), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.name) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control", { 'is-invalid': _ctx.validationErrors.name }]),
                  required: ""
                }, null, 2), [
                  [_vModelText, _ctx.formData.name]
                ]),
                (_ctx.validationErrors.name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.$t('components.assetNotificationRules.validation.nameRequired')), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.description')), 1),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.description) = $event)),
                  class: "form-control",
                  rows: "2"
                }, null, 512), [
                  [_vModelText, _ctx.formData.description]
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.targetType')), 1),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.targetType) = $event)),
                  class: "form-select",
                  onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onTargetTypeChange && _ctx.onTargetTypeChange(...args)))
                }, [
                  _createElementVNode("option", _hoisted_26, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.targetAsset')), 1),
                  _createElementVNode("option", _hoisted_27, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.targetGroup')), 1),
                  (_ctx.hasWirepas)
                    ? (_openBlock(), _createElementBlock("option", _hoisted_28, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.targetGateway')), 1))
                    : _createCommentVNode("", true)
                ], 544), [
                  [_vModelSelect, _ctx.formData.targetType]
                ])
              ]),
              (_ctx.formData.targetType === 'asset')
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.targetAsset')), 1),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.targetAssetId) = $event)),
                      class: _normalizeClass(["form-select", { 'is-invalid': _ctx.validationErrors.targetAssetId }]),
                      required: "",
                      onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onAssetChange && _ctx.onAssetChange(...args)))
                    }, [
                      _createElementVNode("option", _hoisted_31, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.selectAsset')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableAssets, (asset) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: asset.id,
                          value: asset.id
                        }, _toDisplayString(asset.displayName || asset.name || asset.serialNumber), 9, _hoisted_32))
                      }), 128))
                    ], 34), [
                      [_vModelSelect, _ctx.formData.targetAssetId]
                    ]),
                    (_ctx.validationErrors.targetAssetId)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.$t('components.assetNotificationRules.validation.targetAssetRequired')), 1))
                      : _createCommentVNode("", true)
                  ]))
                : (_ctx.formData.targetType === 'group')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.targetGroup')), 1),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.targetAssetGroupId) = $event)),
                        class: _normalizeClass(["form-select", { 'is-invalid': _ctx.validationErrors.targetAssetGroupId }]),
                        required: "",
                        onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onAssetGroupChange && _ctx.onAssetGroupChange(...args)))
                      }, [
                        _createElementVNode("option", _hoisted_36, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.selectGroup')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableGroups, (group) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: group.id,
                            value: group.id
                          }, _toDisplayString(group.displayName), 9, _hoisted_37))
                        }), 128))
                      ], 34), [
                        [_vModelSelect, _ctx.formData.targetAssetGroupId]
                      ]),
                      (_ctx.validationErrors.targetAssetGroupId)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_ctx.$t('components.assetNotificationRules.validation.targetAssetGroupRequired')), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : (_ctx.formData.targetType === 'gateway')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.targetGateway')), 1),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.targetGwId) = $event)),
                          class: _normalizeClass(["form-select", { 'is-invalid': _ctx.validationErrors.targetGwId }]),
                          required: "",
                          onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onGatewayChange && _ctx.onGatewayChange(...args)))
                        }, [
                          _createElementVNode("option", _hoisted_41, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.selectGateway')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableGateways, (gateway) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: gateway.gwId,
                              value: gateway.gwId
                            }, _toDisplayString(gateway.gwId), 9, _hoisted_42))
                          }), 128))
                        ], 34), [
                          [_vModelSelect, _ctx.formData.targetGwId]
                        ]),
                        (_ctx.validationErrors.targetGwId)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(_ctx.$t('components.assetNotificationRules.validation.targetGwIdRequired')), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.parameter')), 1),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.canParamsIoId) = $event)),
                  class: _normalizeClass(["form-select", { 'is-invalid': _ctx.validationErrors.canParamsIoId }]),
                  required: "",
                  disabled: !_ctx.isTargetSelected
                }, [
                  _createElementVNode("option", _hoisted_47, _toDisplayString(_ctx.isTargetSelected
                        ? _ctx.$t('components.assetNotificationRules.form.selectParameter')
                        : (
                          _ctx.formData.targetType === 'asset'
                            ? _ctx.$t('components.assetNotificationRules.form.selectAssetFirst')
                            : _ctx.formData.targetType === 'group'
                              ? _ctx.$t('components.assetNotificationRules.form.selectGroupFirst')
                              : _ctx.$t('components.assetNotificationRules.form.selectGatewayFirst')
                        )), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableParameters, (param) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: param.id,
                      value: param.id
                    }, _toDisplayString(_ctx.getParameterDisplayName(param.paramName)), 9, _hoisted_48))
                  }), 128))
                ], 10, _hoisted_46), [
                  [_vModelSelect, _ctx.formData.canParamsIoId]
                ]),
                (_ctx.validationErrors.canParamsIoId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_ctx.$t('components.assetNotificationRules.validation.parameterRequired')), 1))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.isParameterSelected && !_ctx.isBooleanStateParameter)
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.conditionType')), 1),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.conditionType) = $event)),
                        class: "form-select",
                        required: ""
                      }, [
                        (!_ctx.isBinaryParameter)
                          ? (_openBlock(), _createElementBlock("option", _hoisted_53, _toDisplayString(_ctx.$t('components.assetNotificationRules.conditions.greaterThan')), 1))
                          : _createCommentVNode("", true),
                        (!_ctx.isBinaryParameter)
                          ? (_openBlock(), _createElementBlock("option", _hoisted_54, _toDisplayString(_ctx.$t('components.assetNotificationRules.conditions.lessThan')), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("option", _hoisted_55, _toDisplayString(_ctx.$t('components.assetNotificationRules.conditions.equals')), 1),
                        (!_ctx.isBinaryParameter)
                          ? (_openBlock(), _createElementBlock("option", _hoisted_56, _toDisplayString(_ctx.$t('components.assetNotificationRules.conditions.between')), 1))
                          : _createCommentVNode("", true),
                        (!_ctx.isBinaryParameter)
                          ? (_openBlock(), _createElementBlock("option", _hoisted_57, _toDisplayString(_ctx.$t('components.assetNotificationRules.conditions.outsideRange')), 1))
                          : _createCommentVNode("", true)
                      ], 512), [
                        [_vModelSelect, _ctx.formData.conditionType]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.thresholdValue')), 1),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.thresholdValue) = $event)),
                        type: "number",
                        step: "0.01",
                        class: "form-control",
                        required: ""
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.formData.thresholdValue,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ]),
                    (_ctx.formData.conditionType === 'between' || _ctx.formData.conditionType === 'outside_range')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                          _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.thresholdValueMax')), 1),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.thresholdValueMax) = $event)),
                            type: "number",
                            step: "0.01",
                            class: "form-control",
                            required: ""
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.formData.thresholdValueMax,
                              void 0,
                              { number: true }
                            ]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_ctx.isParameterSelected && _ctx.isBooleanStateParameter)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                      _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.booleanState')), 1),
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("div", _hoisted_65, [
                          _createElementVNode("input", {
                            checked: _ctx.isBooleanThresholdTrue,
                            type: "checkbox",
                            class: "form-check-input",
                            id: "booleanThresholdTrue",
                            onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.setBooleanThreshold(true)))
                          }, null, 40, _hoisted_66),
                          _createElementVNode("label", _hoisted_67, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.enabled')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("input", {
                            checked: !_ctx.isBooleanThresholdTrue,
                            type: "checkbox",
                            class: "form-check-input",
                            id: "booleanThresholdFalse",
                            onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.setBooleanThreshold(false)))
                          }, null, 40, _hoisted_69),
                          _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.disabled')), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
              (_ctx.isDwellParameter)
                ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                    _createElementVNode("label", _hoisted_72, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.dwellThreshold')), 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.timeWindowMinutes) = $event)),
                      type: "number",
                      min: "1",
                      class: _normalizeClass(["form-control", { 'is-invalid': _ctx.validationErrors.timeWindowMinutes }]),
                      required: ""
                    }, null, 2), [
                      [
                        _vModelText,
                        _ctx.formData.timeWindowMinutes,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    (_ctx.validationErrors.timeWindowMinutes)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_73, _toDisplayString(_ctx.$t('components.assetNotificationRules.validation.dwellThresholdRequired')), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_74, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.dwellThresholdHint')), 1))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isAvgParameter)
                ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                    _createElementVNode("label", _hoisted_76, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.timeWindow')), 1),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.timeWindowMinutes) = $event)),
                      class: "form-select"
                    }, [
                      _createElementVNode("option", _hoisted_77, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.defaultTimeWindow')) + " (15 min) ", 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.TIME_WINDOW_OPTIONS, (opt) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: opt.value,
                          value: opt.value
                        }, _toDisplayString(opt.label), 9, _hoisted_78))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.formData.timeWindowMinutes]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("label", _hoisted_80, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.notificationChannels')), 1),
                _createElementVNode("div", _hoisted_81, [
                  _createElementVNode("div", _hoisted_82, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.notificationChannels) = $event)),
                      value: "email",
                      type: "checkbox",
                      class: "form-check-input",
                      id: "channelEmail"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.formData.notificationChannels]
                    ]),
                    _cache[33] || (_cache[33] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "channelEmail"
                    }, " Email ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_83, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.notificationChannels) = $event)),
                      value: "sms",
                      type: "checkbox",
                      class: "form-check-input",
                      id: "channelSms"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.formData.notificationChannels]
                    ]),
                    _cache[34] || (_cache[34] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "channelSms"
                    }, " SMS ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_84, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.notificationChannels) = $event)),
                      value: "mercure",
                      type: "checkbox",
                      class: "form-check-input",
                      id: "channelMercure"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.formData.notificationChannels]
                    ]),
                    _cache[35] || (_cache[35] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "channelMercure"
                    }, " Mercure (Push) ", -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_85, [
                _createElementVNode("div", _hoisted_86, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.isActive) = $event)),
                    type: "checkbox",
                    class: "form-check-input",
                    id: "isActive"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.formData.isActive]
                  ]),
                  _createElementVNode("label", _hoisted_87, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.isActive')), 1)
                ])
              ]),
              _cache[37] || (_cache[37] = _createElementVNode("hr", { class: "my-4" }, null, -1)),
              _createElementVNode("div", _hoisted_88, [
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("div", _hoisted_90, [
                    _createElementVNode("label", _hoisted_91, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.repeatsPerSeries')), 1),
                    _withDirectives(_createElementVNode("input", {
                      id: "repeatsPerSeries",
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.repeatsPerSeries) = $event)),
                      type: "number",
                      min: "0",
                      max: "100",
                      class: _normalizeClass(["form-control", { 'is-invalid': _ctx.validationErrors.repeatsPerSeries }])
                    }, null, 2), [
                      [
                        _vModelText,
                        _ctx.formData.repeatsPerSeries,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    (_ctx.validationErrors.repeatsPerSeries)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_92, _toDisplayString(_ctx.$t('components.assetNotificationRules.validation.repeatsPerSeriesRequired')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_93, [
                    _createElementVNode("label", _hoisted_94, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.repeatIntervalMinutes')), 1),
                    _withDirectives(_createElementVNode("input", {
                      id: "repeatIntervalMinutes",
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formData.repeatIntervalMinutes) = $event)),
                      type: "number",
                      min: "1",
                      class: _normalizeClass(["form-control", { 'is-invalid': _ctx.validationErrors.repeatIntervalMinutes }]),
                      disabled: _ctx.formData.repeatsPerSeries === 0
                    }, null, 10, _hoisted_95), [
                      [
                        _vModelText,
                        _ctx.formData.repeatIntervalMinutes,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    (_ctx.validationErrors.repeatIntervalMinutes)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_96, _toDisplayString(_ctx.$t('components.assetNotificationRules.validation.repeatIntervalMinutesRequired')), 1))
                      : (_ctx.formData.repeatsPerSeries === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_97, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.repeatIntervalDisabledHint')), 1))
                        : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_98, [
                    _createElementVNode("label", {
                      class: _normalizeClass(["form-label", { required: _ctx.formData.repeatsPerSeries > 0 }]),
                      for: "maxMessagesPerHour"
                    }, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.maxMessagesPerHour')), 3),
                    _withDirectives(_createElementVNode("input", {
                      id: "maxMessagesPerHour",
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData.maxMessagesPerHour) = $event)),
                      type: "number",
                      min: "1",
                      class: _normalizeClass(["form-control", { 'is-invalid': _ctx.validationErrors.maxMessagesPerHour }]),
                      disabled: _ctx.formData.repeatsPerSeries === 0
                    }, null, 10, _hoisted_99), [
                      [
                        _vModelText,
                        _ctx.formData.maxMessagesPerHour,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    (_ctx.validationErrors.maxMessagesPerHour)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_100, _toDisplayString(_ctx.$t('components.assetNotificationRules.validation.maxMessagesPerHourRequired')), 1))
                      : (_ctx.formData.repeatsPerSeries === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_101, _toDisplayString(_ctx.$t('components.assetNotificationRules.form.maxMessagesDisabledHint')), 1))
                        : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_102, [
                  _cache[36] || (_cache[36] = _createElementVNode("i", { class: "bi bi-info-circle me-1" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetNotificationRules.form.messagesHint')) + ": ", 1),
                  _createElementVNode("strong", null, _toDisplayString(1 + (_ctx.formData.repeatsPerSeries ?? 0)), 1),
                  _createTextVNode(" / " + _toDisplayString(_ctx.formData.repeatsPerSeries > 0 ? (_ctx.formData.maxMessagesPerHour || 1) : 1), 1)
                ])
              ])
            ], 32)
          ]),
          _createElementVNode("div", _hoisted_103, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-light",
              onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, _toDisplayString(_ctx.$t('components.assetNotificationRules.cancel')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.saveRule && _ctx.saveRule(...args))),
              disabled: _ctx.saving
            }, [
              (_ctx.saving)
                ? (_openBlock(), _createElementBlock("span", _hoisted_105))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetNotificationRules.save')), 1)
            ], 8, _hoisted_104)
          ])
        ])
      ])
    ], 512)
  ]))
}